import ko from './ko'
import Utils from '../Utils'

var koMsg = {
  'agreements.title': '계약서',
  'agreements.error.mandatory': "Deeper 서비스를 계속해서 사용하시려면 동의하셔야 합니다.",
  'agreements.error.blank': "선택해 주십시오.",
  'agreements.back': '뒤로',
  'agreements.agree': '동의',
  'agreements.decline': '거절',
  'agreements.text.full': '완전한 합의'
}

Utils.addTerms(koMsg, ko)

export default koMsg



// WEBPACK FOOTER //
// ./src/lang/koMsg.js